import React from 'react';
import ServiceTemplate from './ServiceTemplate';

const data = {
  title: 'Website',
  subtitle: 'Design',
  tagline: 'Beautiful, High-Converting Designs',
  icon: '',
  // icon: '🎨',

  heroDesc: 'Your website is your digital storefront. We create stunning, user-centric website designs that captivate visitors, communicate your brand story, and drive conversions.',
  mainStat: '300+',
  mainStatLabel: 'Website projects completed',
  subStats: [{ value: '98%', label: 'Client Satisfaction' }, { value: '2x', label: 'Avg Conversion Boost' }],
  features: [
    { icon: '📱', title: 'Mobile-First Design', desc: 'Every design is crafted to look flawless on mobile, tablet, and desktop.' },
    { icon: '🎨', title: 'Custom UI/UX', desc: 'Unique designs tailored to your brand — never generic templates.' },
    { icon: '⚡', title: 'Fast Loading', desc: 'Optimized designs that load in under 3 seconds for better user experience.' },
    { icon: '♿', title: 'Accessibility', desc: 'Designs built to be accessible and inclusive for all users.' },
    { icon: '🔄', title: 'Conversion Optimization', desc: 'Strategic CTAs, layouts, and user flows designed to maximize conversions.' },
    { icon: '🖼️', title: 'Brand Consistency', desc: 'Perfect alignment with your brand colors, fonts, and visual identity.' },
  ],
  benefits: [
    { title: 'Make a Powerful First Impression', desc: 'You have 0.05 seconds to capture a visitor\'s attention. Great design does that.' },
    { title: 'Build Instant Credibility', desc: 'A professional website positions your business as trustworthy and established.' },
    { title: 'Improve User Experience', desc: 'Intuitive navigation keeps visitors engaged and guides them toward conversion.' },
    { title: 'Stand Out from Competition', desc: 'A unique, memorable design gives you a significant competitive advantage.' },
  ],
  process: [
    { title: 'Discovery & Briefing', desc: 'We learn about your business, goals, target audience, and brand preferences.' },
    { title: 'Wireframing', desc: 'Structural blueprints of every page to map out user journeys.' },
    { title: 'Visual Design', desc: 'Full UI design with your brand colors, typography, and visual elements.' },
    { title: 'Review & Revisions', desc: 'You review the designs and we refine until you love every pixel.' },
    { title: 'Handoff & Development', desc: 'Final designs handed off for development or delivered as design files.' },
  ],
  whyChoose: [
    { icon: '🎨', title: 'Unique Every Time', desc: 'No cookie-cutter templates — every design is built from scratch for you.' },
    { icon: '📱', title: 'Mobile Perfection', desc: 'We design for mobile first, ensuring a great experience across all devices.' },
    { icon: '⏱️', title: 'On-Time Delivery', desc: 'We respect deadlines and deliver projects on schedule, always.' },
    { icon: '🔄', title: 'Unlimited Revisions', desc: 'We work until you\'re 100% satisfied with the design.' },
  ],
  reviews: [
    { name: 'Aisha Khan', role: 'Interior Designer', text: 'My new website design is absolutely breathtaking. DMS captured my brand perfectly!' },
    { name: 'Vikram Joshi', role: 'Law Firm', text: 'Professional, modern, and trustworthy — exactly what we needed. Excellent work!' },
    { name: 'Shreya Malhotra', role: 'Wedding Planner', text: 'My website now gets compliments from every client. DMS truly understands design.' },
  ],
  faq: [
    { q: 'How long does website design take?', a: 'A typical website design takes 1–3 weeks depending on the number of pages and complexity.' },
    { q: 'Do you design e-commerce websites?', a: 'Yes! We design e-commerce stores, portfolio sites, business websites, landing pages, and more.' },
    { q: 'Will I own the design files?', a: 'Yes, you receive complete ownership of all design files upon final payment.' },
  ],
};

export default function WebsiteDesign() {
  return <ServiceTemplate data={data} />;
}
